module.exports = __webpack_public_path__ + "img/1525099678.536592b0.jpg";